/*
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-06-08 09:20:18
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-10-08 09:29:09
 */
import { isEmpty } from '@/dragComponents/utils'
export default {
  inject: ['main'],
  data() {
    return {
      loading: false,
      waitting: false,
      dialog: {
        show: false,
        title: '',
        action: 'add',
        index: 0
      },
      column: {}
    }
  },
  methods: {
    loadFeild() {
      if (this.data.apiId) {
        this.getFeild(this.data.apiId)
      }
    },
    getFeild(id) {
      if (!id) return
      this.loading = true
      this.data.apiId = id
      this.$http
        .get(`/apis/main-config/${id}`)
        .then((res) => {
          if (res.code === 200) {
            if (isEmpty(res.data.apisMainOutCtlsModels)) {
              this.$message.error('apis接口输出配置配置出错了，快去查看配置！')
            }
            const list = res.data.apisMainOutCtlsModels.apisMainOutCtlsDataList
            let temp = []
            if (list.length > 0) {
              list.map((item, index) => {
                temp.push({
                  label: item.outPutPath,
                  value: item.outPutPath,
                  disabled: false
                })
              })
            }
            this.main.apiFieldList = temp
            this.data.option.reqMethod = res.data.apisMainConfig.reqMethod
            this.loading = false
          }
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.msg)
        })
    },
    addField(column, isApi = true) {
      if (!this.data.apiId && isApi) {
        this.$notify.error({
          title: '错误',
          message: '请先选择其中一条apis数据'
        })
      } else {
        // 新增之前进行重置操作
        this.column = column
        this.dialog = {
          show: true,
          title: '新增',
          action: 'add',
          index: null
        }
      }
    },
    sortField(row, index, direction) {
      let len = this.data.option.column.length
      let stop = direction === 'up' ? 0 : len - 1
      if (index === stop) return
      let next = direction === 'up' ? index - 1 : index + 1
      this.waitting = true
      let temp = this.data.option.column[next]
      this.$set(this.data.option.column, index, temp)
      this.$set(this.data.option.column, next, row)
      setTimeout(() => {
        this.waitting = false
      }, 500)
    },
    editField(row, index) {
      this.column = row
      this.dialog = {
        show: true,
        title: '编辑',
        action: 'edit',
        index: index
      }
    },
    updateField(val, callback) {
      let index = this.dialog.index
      let action = this.dialog.action
      if (action === 'edit') {
        if (Array.isArray(val)) {
          this.$set(this.data.option, 'column', val)
        } else {
          this.$set(this.data.option.column, index, val)
        }
      } else {
        if (Array.isArray(val)) {
          this.$set(this.data.option, 'column', val)
        } else {
          this.data.option.column.push(val)
        }
      }
      this.column = Array.isArray(val) ? [] : {}
      callback && callback(val)
    },
    deleteField(row, index, callback) {
      this.data.option.column.splice(index, 1)
      callback && callback(row)
    }
  }
}
